export default __webpack_public_path__ + "static/media/section2b-grid5img.ce4eba72.svg";